import { render, staticRenderFns } from "./EmployeeComponent.vue?vue&type=template&id=1071f3a4"
import script from "./EmployeeComponent.vue?vue&type=script&lang=ts"
export * from "./EmployeeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports